import { useState } from 'react'
import {
  Container,
  Button,
  Embed,
  Dots,
  Dot
} from './styles'

type Props = {
  videos: string[]
}

export function YoutubeCarousel ({ videos }: Props) {
  const [currentVideoId, setCurrentVideoId] = useState<number>(0)

  function handlePreviousVideo () {
    if (currentVideoId === 0) {
      setCurrentVideoId(videos.length - 1)
    } else {
      setCurrentVideoId(state => state - 1)
    }
  }

  function handleNextVideo () {
    if (currentVideoId === videos.length - 1) {
      setCurrentVideoId(0)
    } else {
      setCurrentVideoId(state => state + 1)
    }
  }

  return (
      <Container>
        {videos.length > 1 && <Button onClick={handlePreviousVideo}>&lt;</Button>}

        <Embed src={videos[currentVideoId]}
          frameBorder='0'
          allow='autoplay; encrypted-media'
          allowFullScreen
          title='video'
        />

        {videos.length > 1 && <Button onClick={handleNextVideo}>&gt;</Button>}

        <Dots>
          {
            videos.map((v, idx) => <Dot key={v} isCurrent={idx === currentVideoId} />)
          }
        </Dots>
      </Container>
  )
}
